import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CounterComponent } from './counter/counter.component';
import { BrowserModule } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';

@NgModule({
  imports: [
    CommonModule, BrowserModule
  ],
  declarations: [CounterComponent],
   schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
     entryComponents : [
    CounterComponent
  ],
    providers: []
})
export class PrimoModule { constructor(private injector: Injector) {
    const el = createCustomElement(CounterComponent, {injector : this.injector});
    customElements.define('counter-test', el);
  }

  ngDoBootstrap() {
   // const el = createCustomElement(CounterComponent, {injector : this.injector});
   // customElements.define('counter', el);
   }
}
